import { AllStatusesTypes } from 'interfaces';

type TaskByStatusParams = {
  status: AllStatusesTypes;
  isOwner: boolean;
};

export const taskKeys = {
  all: ['tasks'] as const,
  favourites: [...(['tasks'] as const), 'favourites'] as const,
  task: (id: string) => [...taskKeys.all, id] as const,
  taskByStatus: (params: TaskByStatusParams) =>
    [...taskKeys.all, params] as const,
};
